<template>
	<section class="checkboxTabs">
		<el-checkbox v-if="!showAll" :indeterminate="isIndeterminate" v-model="checkAll" :disabled="isunit" @change="handleCheckAllChange">全选</el-checkbox>
		<el-checkbox-group v-model="checkeds" :disabled="disabled" @change="change">
			<el-checkbox v-for="city in options" :label="city.key" :key="city.key" :disabled="city.disabled||unitDisabledFn(unitArr,city.key)">
				{{city.name}}
			</el-checkbox>
		</el-checkbox-group>
	</section>
</template>

<script>
	import Vue, { Component } from 'C/BaseVue'
	import { getConstantByKeyword,deepCopy } from 'service/utils'

	@Component({
		props: [ 'groupName', 'result', 'showAll', 'groupDate', 'disabled', 'unitdisabled' ],
		watch: {
			checkeds : {
				handler(curVal, oldVal){
					this.$emit('update:result', curVal)
				}
			},
			result : {
				handler(curVal, oldVal){
					if(!curVal){ return false}
						let checkedCount = curVal.length
					let optionCount = this.options.length
					this.isIndeterminate = checkedCount > 0 && checkedCount < optionCount
					this.checkAll = checkedCount == optionCount&&optionCount>0
					this.checkeds = curVal
				},
				immediate: true
			},
			groupDate : {
				handler(curVal, oldVal){
					if(typeof curVal !== 'object') return false;
					this.options = curVal
				}
			},
			unitdisabled : {
				handler(curVal, oldVal){
					if(typeof curVal !== 'object') return false;
					this.unitArr = curVal.data
					this.isunit = curVal.disabled
				}
			}
		}
	})

	export default class CheckboxTabs extends Vue {

		isIndeterminate = false
		checkAll = false
		checkeds = []
		options = []
		valueAll = []
		unitArr = []
		isunit = false
		mounted(){
			if(this.groupDate){ // 引用外部数据源
				this.options = this.groupDate
				this.valueAll = this.options.map(item => {
					return item.key
				})
				return false
			}
			if(this.unitdisabled&&this.unitdisabled.disabled){ // 单条禁用操作
				this.unitArr = this.unitdisabled.data
				this.isunit = this.unitdisabled.disabled
			}
			/* 组件自带数据源 */
			let Arr = []
			let constantNames = [
			'APPROVAL_CHECK_TAB',
			'ACTIVITY_TYPE', //活动类型
			'CUSTOMER_FOLLOW_TYPE',
			]
			switch(this.groupName){
				case 'filiale':
				Arr = getConstantByKeyword('filiale').map(item => {
					return {
						name : item.dep_name,
						key : item.id,
						disabled : !item.status
					}
				})
				break;
				case 'grade':
				Arr = getConstantByKeyword('grade').map(item => {
					return {
						name : item.grade_name,
						key : item.id,
						disabled : !item.status
					}
				})
				break;
				case 'subject':
				Arr = getConstantByKeyword('subject').map(item => {
					return {
						name : item.subject_name,
						key : item.id,
						disabled : !item.status
					}
				})
				break;
				case 'mySelf'://自带数据学生
				Arr = this.groupDate.map(item => {
					return {
						name : item.student_name,
						key : item.class_student_id,
						disabled : !item.status
					}
				})
				break;
				default:
				if(constantNames.indexOf(this.groupName) > -1){
					Arr = this.getGroupData()
				}else{
					console.log('未定义的'+this.groupName)
				}
				break;
			}

			this.options = Arr
			this.valueAll = Arr.map(item => {
				return item.key
			})
		}

		handleCheckAllChange(val){
			this.checkeds = val ? this.valueAll : []
			this.isIndeterminate = false
		}

		getGroupData(){
			return getConstantByKeyword(this.groupName).map(item => {
				return {
					name : item.item_name,
					key : item.item_value,
					disabled : !item.status
				}
			})
		}

		unitDisabledFn(data,id){// 单条禁用操作
			if(data&&id){
				return this.isunit&&data.includes(id)
			}
		}

		change(val){
			this.$emit('callback',val)
		}
	}

</script>

<style lang="scss" type="text/css">
.checkboxTabs{
	.el-checkbox{
		margin-left: 0 !important;
		margin-right: 15px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/CheckboxTabs.vue